// @core/api/endpoints/secret/generate_intermediate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateIntermediateRequest,
  GenerateIntermediateResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Generate intermediate CSR
 * Generates a Certificate Signing Request (CSR) for an intermediate CA. The CSR must be signed by a root CA (via SignIntermediate) to create the intermediate certificate.
 */
export async function GenerateIntermediate(
  engine_id: string,
  data: GenerateIntermediateRequest,
  options?: RequestOptions
): Promise<GenerateIntermediateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/intermediate/generate`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<GenerateIntermediateResponse>(requestPath, data, requestOptions);
}
